import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import type { SubscriptionModel } from "@/features/common/api/useSubscription";

export interface ChangePaymentCardRequestModel {
	readonly paymentCardId: string;
}

export const useChangePaymentCard = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, ChangePaymentCardRequestModel> = requestModel => {
		return http<undefined, ChangePaymentCardRequestModel>({
			method: "POST",
			url: "/subscription/change-payment-card",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, requestModel) => {
			queryClient.setQueryData(["subscription"], (oldData: SubscriptionModel | undefined) => {
				if (!oldData) {
					return oldData;
				}

				return {
					...oldData,
					autoRenewPaymentCardId: requestModel.paymentCardId
				};
			});
		}
	});
};
